<div id="headernew" class="container-fluid header">
    <header>
        <!-- <div id="demoproj" *ngIf="this.defaultId == '1'">DEMO PROJECT</div> -->
        <div id="myModal" class="modal">
            <!-- Modal content -->

            <div class="modal-content">
                <p class="editProject"> Delete Client</p>
                <div class="modal-info-edit">
                    <p>{{delname }} will be deleted from database</p>
                    <div class="d-flex mt-4 mb-4">

                        <button id="cancl" class="mr-2" mat-raised-button color="primary">Cancel</button>
                        <button id="delt" type="button" mat-raised-button color="primary">Delete</button>
                    </div>
                </div>
            </div>
        </div>
        <div id="myModaldelete" class="modal">
            <!-- Modal content -->
            <div class="modal-content">
                <p class="editProject"> Delete project</p>
                <div class="modal-info-edit">
                    <p>{{delprojname }} project will be deleted from database</p>
                    <div class="d-flex mt-4 mb-4">
                        <button type="button" class="mr-2" mat-raised-button color="primary" id="canclproj">Cancel</button>
                        <button id="deltproj" type="button" mat-raised-button
                            color="primary">Delete</button>
                    </div>
                </div>
            </div>

        </div>
        <div id="myModaledit" class="modal">

            <!-- Modal content -->
            <div class="modal-content">

                <p class="editProject"> Edit project</p>
                <div class="modal-info-edit">
                    <p>Project Name</p>
                    <mat-form-field class="example-full-width w-100">

                    <input id="edpro" class="w-100" matInput placeholder={{editprojname}} [(ngModel)]="projName">
                    </mat-form-field>

                    <div class="d-flex mt-4 mb-4">
                        <button class="mr-2" mat-raised-button color="default" id="cancledit">BACK</button>
                        <button  id="editproj" [disabled]="!projName" mat-raised-button
                            color="primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
        <mat-toolbar class="navToolbar custom-nav-toolbar">
            <div class="col-md-2 pt-2">
                <img class="adeosLogo " src="assets/images/logo1.png" />

            </div>
            <div class="col-md-10 col-10 " *ngIf="isLoggedIn$ | async as isLoggedIn">
                <div class="row">
                    <mat-form-field class="col-md-3 pt-4 form-field"
                        *ngIf="this.newEmail == 'anuprathi1@gmail.com'">
                        <mat-select placeholder="" class="form-field-select" (selectionChange)="modo($event)">
                            <mat-option (click)="addNewClient()" id="selectProj" class="form-field-option">
                                Add Client <img id="navedit" (click)="addNewClient()" class="editclient"
                                    src="assets/images/addclient.png" />
                            </mat-option>
                            <mat-option id="imgloop" *ngFor="let builder of dropdownData?.clientLists"
                                [value]="builder.id">
                                {{ builder.name }}
                                <img id="navedit" #cliEdit [value]="builder" (click)="edclit(cliEdit.value)"
                                    class="editclient" src="assets/images/edit.png" />
                                <img id="delclinet" #titleInput [value]="builder" (click)="helloalt(titleInput?.value)"
                                    class="deleteclient " src="assets/images/dlt.png" />
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <!-- admin start -->
                    <mat-form-field class="col-md-3 pt-4" *ngIf="this.newEmail == 'anuprathi1@gmail.com'">
                        <mat-select name="food" class="form-field-select" placeholder="" (selectionChange)="projListDetails($event)">
                            <mat-options id="selectProj">Please select a Project</mat-options>
                            <mat-option
                                *ngIf="this.newEmail == 'anuprathi1@gmail.com' && btnStatus$ | async as btnStatus">
                                <button id="addproject" [routerLink]="['logedin']" class="col-md-12" type="button"
                                    mat-raised-button color="primary">Add Project</button></mat-option>
                            <mat-option (click)="refreshmrfd()" *ngFor="let food of projData?.clientLists"
                                [value]="food.id" selected="selectedValue.id">


                                {{ food.proj_name }}
                                <img id="projedit" #projEdit [value]="food" (click)="editProject(projEdit.value)"
                                    class="editclient " src="assets/images/edit.png" />
                                <img id="delclinet" #projInput [value]="food" (click)="delProject(projInput.value)"
                                    class="deleteclient " src="assets/images/dlt.png" />
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <!-- admin end -->
                    <mat-form-field class="col-md-3 pt-4" *ngIf="this.newEmail !== 'anuprathi1@gmail.com'">
                        <mat-select [(ngModel)]="selectedValue" name="food" (click)="loadProjects()" placeholder=""
                            (selectionChange)="projListDetails($event)" class="form-field-select">
                            <mat-options id="selectProj">Please select a Project</mat-options>
                            <mat-option (click)="refreshmrfd()" *ngFor="let food of projData?.clientLists"
                                [value]="food.id" selected="selectedValue.id">


                                {{ food.proj_name }}
                                <img *ngIf="this.newEmail !== 'demo@ecomatrix.io'" id="projedit" #projEdit
                                    [value]="food" (click)="editProject(projEdit.value)" class="editclient "
                                    src="assets/images/edit.png" />
                                <img *ngIf="this.newEmail !== 'demo@ecomatrix.io'" id="delclinet" #projInput
                                    [value]="food" (click)="delProject(projInput.value)" class="deleteclient "
                                    src="assets/images/dlt.png" />
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <div class="col-md-4 pt-4 text-right" id="logoutbtn">
                        <button mat-button [matMenuTriggerFor]="menu"><span>Hello {{newCname}} </span> </button>
                        <mat-menu #menu="matMenu">

                            <button *ngIf="this.newEmail !== 'demo@ecomatrix.io'" mat-menu-item>Profile</button>
                            <button *ngIf="this.newEmail !== 'demo@ecomatrix.io'" mat-menu-item
                                (click)="onLogout()">Logout </button>
                        </mat-menu>
                    </div>
                </div><!--end of inner row -->
            </div>
        </mat-toolbar>
    </header>
    <div class="innerBorder"></div>
</div>